var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailValidArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610,
    height: 610,
    viewBox: "0 0 610 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_valid_art",
    transform: "translate(-218 -297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hello-bro",
    transform: "translate(164.029 258.983)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-229",
    transform: "translate(84.499 86.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M314.276,123.85V90c-25.943,6.451-49.757,17.817-73.116,33.818Z",
    transform: "translate(21.387 -83.764)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 179.049,
    height: 222.23,
    transform: "translate(345.856 52.282)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M352.549,119.41H262.665c-20.087,15.03-40.707,30.249-64.771,38.922-8.048,2.912-16.189,5.464-24.393,7.828V341.64H352.549Z",
    transform: "translate(-16.886 -67.128)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M440.463,154.067A145.2,145.2,0,0,0,415.24,121V340.741h18.412C461.959,284.111,471.228,209.883,440.463,154.067Z",
    transform: "translate(119.858 -66.228)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M219.907,151.1c-9.754,2.677-19.586,5.2-29.419,7.828C113.442,179.517,65.673,248.75,74.519,323.714H219.907Z",
    transform: "translate(-73.469 -49.202)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M415.24,269.146v18.3q3.4-4.54,6.5-9.394c1.847-2.9,3.632-5.887,5.386-8.924Z",
    transform: "translate(119.858 17.563)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M473.419,269.14H294.37v93.721c14.889.188,29.654,1.378,44.715-.266,49.444-5.386,100.109-25.614,134.334-62.908Z",
    transform: "translate(51.486 17.569)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M294.37,126.1H466.5c-34.93-26.021-80.225-38.954-123.093-39.987a226.426,226.426,0,0,0-49.037,3.9Z",
    transform: "translate(51.486 -86.017)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M352.549,269.14H173.5V402.535c31.047.532,62.235-8.392,91.67-18.381,23.391-7.922,46.97-16.126,71.676-19.821a133.683,133.683,0,0,1,15.657-1.346Z",
    transform: "translate(-16.886 17.569)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M218.826,269.14H75.38c11.3,54.8,54.923,104.759,109.784,125.331A125.928,125.928,0,0,0,218.826,402Z",
    transform: "translate(-72.389 17.569)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M314.276,123.85V90c-25.943,6.451-49.757,17.817-73.116,33.818Z",
    transform: "translate(21.387 -83.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 179.049,
    height: 222.23,
    transform: "translate(345.856 52.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M352.549,119.41H262.665c-20.087,15.03-40.707,30.249-64.771,38.922-8.048,2.912-16.189,5.464-24.393,7.828V341.64H352.549Z",
    transform: "translate(-16.886 -67.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M440.463,154.067A145.2,145.2,0,0,0,415.24,121V340.741h18.412C461.959,284.111,471.228,209.883,440.463,154.067Z",
    transform: "translate(119.858 -66.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M219.907,151.1c-9.754,2.677-19.586,5.2-29.419,7.828C113.442,179.517,65.673,248.75,74.519,323.714H219.907Z",
    transform: "translate(-73.469 -49.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M415.24,269.146v18.3q3.4-4.54,6.5-9.394c1.847-2.9,3.632-5.887,5.386-8.924Z",
    transform: "translate(119.858 17.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M473.419,269.14H294.37v93.721c14.889.188,29.654,1.378,44.715-.266,49.444-5.386,100.109-25.614,134.334-62.908Z",
    transform: "translate(51.486 17.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M294.37,126.1H466.5c-34.93-26.021-80.225-38.954-123.093-39.987a226.426,226.426,0,0,0-49.037,3.9Z",
    transform: "translate(51.486 -86.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M352.549,269.14H173.5V402.535c31.047.532,62.235-8.392,91.67-18.381,23.391-7.922,46.97-16.126,71.676-19.821a133.683,133.683,0,0,1,15.657-1.346Z",
    transform: "translate(-16.886 17.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M218.826,269.14H75.38c11.3,54.8,54.923,104.759,109.784,125.331A125.928,125.928,0,0,0,218.826,402Z",
    transform: "translate(-72.389 17.569)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-229",
    transform: "translate(331.484 410.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M544.275,293.02H231.22V306.3h6.638v134.96H537.636V306.3h6.638Z",
    transform: "translate(-231.22 -293.02)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M544.275,293.02H231.22V306.3h6.638v134.96H537.636V306.3h6.638Z",
    transform: "translate(-231.22 -293.02)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M240.58,353.842h81.775V310.16H240.58Zm1.66-42.022H320.7v40.363H242.24Z",
    transform: "translate(-225.925 -283.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M305.44,353.842H387.2V310.16H305.44Zm1.66-42.022h78.44v40.363H307.1Z",
    transform: "translate(-189.236 -283.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M370.29,310.16v43.682h81.759V310.16Zm80.1,42.022H371.95V311.82h78.44Z",
    transform: "translate(-152.553 -283.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M240.58,391.3h81.775V347.6H240.58Zm1.66-42.038H320.7v40.378H242.24Z",
    transform: "translate(-225.925 -262.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M305.44,391.3H387.2V347.6H305.44Zm1.66-42.038h78.44v40.378H307.1Z",
    transform: "translate(-189.236 -262.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M370.29,391.3h81.759V347.6H370.29Zm1.66-42.038h78.44v40.378H371.95Z",
    transform: "translate(-152.553 -262.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 13.277,
    cy: 4.979,
    rx: 13.277,
    ry: 4.979,
    transform: "translate(43.134 44.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 13.277,
    cy: 4.979,
    rx: 13.277,
    ry: 4.979,
    transform: "translate(144.182 44.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 13.277,
    cy: 4.979,
    rx: 13.277,
    ry: 4.979,
    transform: "translate(248.173 44.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M272.041,358.73c-7.327,0-13.261,2.223-13.261,4.979s5.934,4.979,13.261,4.979,13.277-2.223,13.277-4.979S279.384,358.73,272.041,358.73Z",
    transform: "translate(-215.63 -255.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M336.581,358.73c-7.327,0-13.261,2.223-13.261,4.979s5.934,4.979,13.261,4.979,13.277-2.223,13.277-4.979S343.924,358.73,336.581,358.73Z",
    transform: "translate(-179.122 -255.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M403.007,358.73c-7.327,0-13.277,2.223-13.277,4.979s5.95,4.979,13.277,4.979,13.277-2.223,13.277-4.979S410.334,358.73,403.007,358.73Z",
    transform: "translate(-141.557 -255.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-229",
    transform: "translate(53.971 307.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M217.409,318.388c-6.043,8.956-14.467,20.62-18.96,29.982,1.707-6.169,3.382-11.993,4.9-17.222,2.3-4.509,8.47-15.938,15.657-23.485,9.034-9.676,12.9-15.876,8.032-16.424-3.366-.376-13.23,12.76-19.414,25.818,1.346-4.462,2.411-7.828,3.053-9.864.3-.892.579-1.894.861-2.943a258.928,258.928,0,0,0,17.441-27.963c9.128-17.066,12.071-33.161,5.981-26.225-5.605,6.372-15.359,38.046-23.094,52.966.642-2.568,1.268-5.417,1.816-8.22,1.1-2.709,2.536-5.464,3.351-7.969,1.268-3.836,2.38-7.734,3.272-11.68a81.2,81.2,0,0,0,2.223-18.788,38.062,38.062,0,0,0-5.824-21.042c-1.049-1.566-7.453-11.148-9.394-6.263a5.276,5.276,0,0,0-.141,2.521c.939,8.157,3.9,15.657,5.73,23.595,2.74,11.883.924,31.846,0,40.332-.344,1.331-.783,3.006-1.3,4.932,1.268-14.8-5.135-32.315-11.069-35.368-7.343-3.789-.141,11.085,5.527,24.064a38.656,38.656,0,0,1,3.679,18.224c-1.159,4.274-2.489,9.065-3.867,13.919-.266.673-.532,1.331-.783,1.988a41.567,41.567,0,0,0,.783-9.629c-.548-8.486-10.161-25.473-16.549-23.078s4.431,11.367,10.208,21.794a31.422,31.422,0,0,1,3.225,18.584,9.347,9.347,0,0,1-.172,1.127c-.658,2.208-1.315,4.353-1.957,6.372-1.566,4.7-2.9,9.206-4.227,13.559a67.826,67.826,0,0,0,2.129-19.336c-.8-12.447-8.079-24.19-14.091-25.786s5.464,18.678,9.316,30.076a40.9,40.9,0,0,1,1.033,20.573c-1.863,6.169-3.617,12.243-5.417,18.694a155.628,155.628,0,0,0-.532-25.285c-1.174-13.84-9.394-22.686-15.077-22.326s.251,8.22,8.423,25.051a56.254,56.254,0,0,1,5.574,28.464c-.736,2.724-1.566,5.511-2.255,8.423-.877,3.319-1.566,6.92-2.176,10.615-.83-3.288-2.051-8.11-3.476-13.433a119.381,119.381,0,0,1-3.6-17.974c-.767-7.061-2.63-15.86-9.551-19.54a3.9,3.9,0,0,0-5.793,1.566,7.688,7.688,0,0,0-.423,4.791,52.811,52.811,0,0,0,4.7,13.809,15.938,15.938,0,0,0-1.8,8.47c0,1.112.094,2.208.172,3.288-.611-1.112-1.19-2.145-1.738-3.131a20.245,20.245,0,0,0-3.632-4.478,58.1,58.1,0,0,0,.532-7.828c0-3.444-4.024-12.181-7.656-5.7-1.44,2.583-1.174,7.687-1.315,11.069-.986.924-1.284,2.834-.454,5.856a75.418,75.418,0,0,0,1.221,23.485l-1.237-2.192a171.954,171.954,0,0,1-3.131-27.462c-.595-15.2,1.816-27.728-2.317-32.425s-6.466,11.821-4.7,29.748a75.152,75.152,0,0,0,6.482,23.751c-4.071-7.312-8.094-14.764-11.9-21.919-1.566-3.852-5.449-14.216-4.493-24.737,1.206-13.277,2.082-24.127-2.959-31.6s-6.09-2.63-3.617,12.932c1.691,10.693,3.491,24.972,6.607,34.883-2.959-5.683-5.73-11.085-8.2-15.985-1.409-4.869-4.7-17.426-4.7-27.837,0-13.23-1.425-20.354-5.339-17.489-2.724,2.035-.971,18.365,3.413,32.112-2.051-4.18-3.6-7.39-4.493-9.284-.407-.861-.861-1.769-1.378-2.74a258.868,258.868,0,0,0-6.263-32.331c-4.963-18.788-13.793-32.472-13.527-23.266.251,8.486,14.749,38.3,19.273,54.485-1.284-2.317-2.771-4.822-4.274-7.249-1.049-2.724-1.879-5.715-2.99-8.11-1.707-3.664-3.538-7.28-5.589-10.772a80.771,80.771,0,0,0-11.21-15.281,38.03,38.03,0,0,0-18.631-11.4c-1.847-.438-13.058-3.131-11.148,1.879a5.48,5.48,0,0,0,1.566,1.941c6.263,5.323,13.527,8.783,20.354,13.339,10.114,6.811,22.4,22.64,27.477,29.5L106,318.419c-9.159-11.68-25.8-20.119-32.221-18.3-7.954,2.239,7.468,8.2,20.463,13.825a38.53,38.53,0,0,1,15.124,10.819c2.067,3.9,4.368,8.314,6.67,12.807.266.673.517,1.331.8,1.973a41.474,41.474,0,0,0-6.012-7.562C104.556,326.154,86,320.3,82.981,326.4s10.96,5.276,22.326,8.956a31.313,31.313,0,0,1,15.2,11.4l.642.955c1.033,2.067,2,4.071,2.928,6,2.129,4.478,4.165,8.689,6.169,12.792A67.746,67.746,0,0,0,118.6,350.844c-9.081-8.549-22.42-12.165-27.947-9.19s16.753,9.926,27.336,15.657a40.864,40.864,0,0,1,14.8,14.326c2.85,5.777,5.715,11.429,8.8,17.363a157.038,157.038,0,0,0-17.739-18.115c-10.3-9.3-22.358-10.146-26.256-6.028s5.793,5.84,23.234,12.525a56.364,56.364,0,0,1,23.485,17c1.315,2.489,2.662,5.041,4.1,7.687a104.911,104.911,0,0,0,5.652,9.253c-2.849-1.847-7.045-4.54-11.711-7.453A118.19,118.19,0,0,1,127.462,393.2c-5.386-4.7-12.76-9.8-20.354-7.828a3.914,3.914,0,0,0-3.131,5.1,7.641,7.641,0,0,0,2.959,3.789c7.139,5.542,16.737,8.2,25.051,11.461a186.124,186.124,0,0,0,23.375,7.468c1.973,2.834,4.039,5.621,6.09,8.3l-3.726.11c-4.415.125-24.33-8.893-34.445-11.805s-19.571,2.6-8.971,8.3,39.423,4.431,39.423,4.431l8.314-.2c1.957,2.505,3.883,4.869,5.683,7.045H128.245v10.96h7.828l6.263,38.954h52.591l6.263-38.922h7.828v-10.96H182.839a99.792,99.792,0,0,1,.376-14.185,33.286,33.286,0,0,1,5.777-4.7c11.492-7.938,30.969-8.6,36.151-23.876,1.253-3.695-.157-8.423-4.572-8.22-3.131.157-6.529,2.928-8.5,5.214-6.576,7.594-11.523,15.469-20.072,21.215-.391.266-5.777,4.556-8.455,7.218.3-2.489.673-5.151,1.159-8.016a78.712,78.712,0,0,1,7.045-10.443c7-8.674,17.645-13.762,25.207-22.045,2.317-2.536,5.37-11.648-1.707-9.394-3.131,1.018-6.858,5.777-9.316,7.969-6.952,6.263-14.091,12.932-18.631,21.168.188-.814.391-1.566.579-2.458a174.728,174.728,0,0,1,16.439-22.185c10.052-11.445,20.354-18.929,20.526-25.176s-12.791,4.227-23.8,18.569a75.027,75.027,0,0,0-11.461,21.778c2.02-8.126,4.165-16.314,6.263-24.174,1.44-3.914,5.715-14.091,13.59-21.152,9.942-8.877,17.989-16.2,19.414-25.051S226.24,305.315,217.409,318.388Zm-55.6,100.7q-2.223-3.037-4.7-6.638a78.282,78.282,0,0,1-1.957-12.447,51.509,51.509,0,0,1,.485-10.756,123.111,123.111,0,0,0,8.5,9.488A47.316,47.316,0,0,1,163,408.053c-.047.454-1.049,7.265-1.19,11.038Zm8.517,10.3a99.62,99.62,0,0,1-6.623-7.828,32.878,32.878,0,0,1,1.018-7.359,53,53,0,0,1,4.1-10.96c3.711,3.523,6.435,5.871,6.435,5.871l6.263,5.48c-.485,5.48-.767,10.6-.939,14.764ZM181.6,413.643l-2.8-2.458c-1.566-1.409-4.384-6.858-7.453-13.12a74.773,74.773,0,0,0,3.476-8.141c3.319,6.153,6.263,10.96,8,13.512C182.4,406.848,181.931,410.292,181.6,413.643Z",
    transform: "translate(-53.971 -227.692)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M217.409,318.388c-6.043,8.956-14.467,20.62-18.96,29.982,1.707-6.169,3.382-11.993,4.9-17.222,2.3-4.509,8.47-15.938,15.657-23.485,9.034-9.676,12.9-15.876,8.032-16.424-3.366-.376-13.23,12.76-19.414,25.818,1.346-4.462,2.411-7.828,3.053-9.864.3-.892.579-1.894.861-2.943a258.928,258.928,0,0,0,17.441-27.963c9.128-17.066,12.071-33.161,5.981-26.225-5.605,6.372-15.359,38.046-23.094,52.966.642-2.568,1.268-5.417,1.816-8.22,1.1-2.709,2.536-5.464,3.351-7.969,1.268-3.836,2.38-7.734,3.272-11.68a81.2,81.2,0,0,0,2.223-18.788,38.062,38.062,0,0,0-5.824-21.042c-1.049-1.566-7.453-11.148-9.394-6.263a5.276,5.276,0,0,0-.141,2.521c.939,8.157,3.9,15.657,5.73,23.595,2.74,11.883.924,31.846,0,40.332-.344,1.331-.783,3.006-1.3,4.932,1.268-14.8-5.135-32.315-11.069-35.368-7.343-3.789-.141,11.085,5.527,24.064a38.656,38.656,0,0,1,3.679,18.224c-1.159,4.274-2.489,9.065-3.867,13.919-.266.673-.532,1.331-.783,1.988a41.567,41.567,0,0,0,.783-9.629c-.548-8.486-10.161-25.473-16.549-23.078s4.431,11.367,10.208,21.794a31.422,31.422,0,0,1,3.225,18.584,9.347,9.347,0,0,1-.172,1.127c-.658,2.208-1.315,4.353-1.957,6.372-1.566,4.7-2.9,9.206-4.227,13.559a67.826,67.826,0,0,0,2.129-19.336c-.8-12.447-8.079-24.19-14.091-25.786s5.464,18.678,9.316,30.076a40.9,40.9,0,0,1,1.033,20.573c-1.863,6.169-3.617,12.243-5.417,18.694a155.628,155.628,0,0,0-.532-25.285c-1.174-13.84-9.394-22.686-15.077-22.326s.251,8.22,8.423,25.051a56.254,56.254,0,0,1,5.574,28.464c-.736,2.724-1.566,5.511-2.255,8.423-.877,3.319-1.566,6.92-2.176,10.615-.83-3.288-2.051-8.11-3.476-13.433a119.381,119.381,0,0,1-3.6-17.974c-.767-7.061-2.63-15.86-9.551-19.54a3.9,3.9,0,0,0-5.793,1.566,7.688,7.688,0,0,0-.423,4.791,52.811,52.811,0,0,0,4.7,13.809,15.938,15.938,0,0,0-1.8,8.47c0,1.112.094,2.208.172,3.288-.611-1.112-1.19-2.145-1.738-3.131a20.245,20.245,0,0,0-3.632-4.478,58.1,58.1,0,0,0,.532-7.828c0-3.444-4.024-12.181-7.656-5.7-1.44,2.583-1.174,7.687-1.315,11.069-.986.924-1.284,2.834-.454,5.856a75.418,75.418,0,0,0,1.221,23.485l-1.237-2.192a171.954,171.954,0,0,1-3.131-27.462c-.595-15.2,1.816-27.728-2.317-32.425s-6.466,11.821-4.7,29.748a75.152,75.152,0,0,0,6.482,23.751c-4.071-7.312-8.094-14.764-11.9-21.919-1.566-3.852-5.449-14.216-4.493-24.737,1.206-13.277,2.082-24.127-2.959-31.6s-6.09-2.63-3.617,12.932c1.691,10.693,3.491,24.972,6.607,34.883-2.959-5.683-5.73-11.085-8.2-15.985-1.409-4.869-4.7-17.426-4.7-27.837,0-13.23-1.425-20.354-5.339-17.489-2.724,2.035-.971,18.365,3.413,32.112-2.051-4.18-3.6-7.39-4.493-9.284-.407-.861-.861-1.769-1.378-2.74a258.868,258.868,0,0,0-6.263-32.331c-4.963-18.788-13.793-32.472-13.527-23.266.251,8.486,14.749,38.3,19.273,54.485-1.284-2.317-2.771-4.822-4.274-7.249-1.049-2.724-1.879-5.715-2.99-8.11-1.707-3.664-3.538-7.28-5.589-10.772a80.771,80.771,0,0,0-11.21-15.281,38.03,38.03,0,0,0-18.631-11.4c-1.847-.438-13.058-3.131-11.148,1.879a5.48,5.48,0,0,0,1.566,1.941c6.263,5.323,13.527,8.783,20.354,13.339,10.114,6.811,22.4,22.64,27.477,29.5L106,318.419c-9.159-11.68-25.8-20.119-32.221-18.3-7.954,2.239,7.468,8.2,20.463,13.825a38.53,38.53,0,0,1,15.124,10.819c2.067,3.9,4.368,8.314,6.67,12.807.266.673.517,1.331.8,1.973a41.474,41.474,0,0,0-6.012-7.562C104.556,326.154,86,320.3,82.981,326.4s10.96,5.276,22.326,8.956a31.313,31.313,0,0,1,15.2,11.4l.642.955c1.033,2.067,2,4.071,2.928,6,2.129,4.478,4.165,8.689,6.169,12.792A67.746,67.746,0,0,0,118.6,350.844c-9.081-8.549-22.42-12.165-27.947-9.19s16.753,9.926,27.336,15.657a40.864,40.864,0,0,1,14.8,14.326c2.85,5.777,5.715,11.429,8.8,17.363a157.038,157.038,0,0,0-17.739-18.115c-10.3-9.3-22.358-10.146-26.256-6.028s5.793,5.84,23.234,12.525a56.364,56.364,0,0,1,23.485,17c1.315,2.489,2.662,5.041,4.1,7.687a104.911,104.911,0,0,0,5.652,9.253c-2.849-1.847-7.045-4.54-11.711-7.453A118.19,118.19,0,0,1,127.462,393.2c-5.386-4.7-12.76-9.8-20.354-7.828a3.914,3.914,0,0,0-3.131,5.1,7.641,7.641,0,0,0,2.959,3.789c7.139,5.542,16.737,8.2,25.051,11.461a186.124,186.124,0,0,0,23.375,7.468c1.973,2.834,4.039,5.621,6.09,8.3l-3.726.11c-4.415.125-24.33-8.893-34.445-11.805s-19.571,2.6-8.971,8.3,39.423,4.431,39.423,4.431l8.314-.2c1.957,2.505,3.883,4.869,5.683,7.045H128.245v10.96h7.828l6.263,38.954h52.591l6.263-38.922h7.828v-10.96H182.839a99.792,99.792,0,0,1,.376-14.185,33.286,33.286,0,0,1,5.777-4.7c11.492-7.938,30.969-8.6,36.151-23.876,1.253-3.695-.157-8.423-4.572-8.22-3.131.157-6.529,2.928-8.5,5.214-6.576,7.594-11.523,15.469-20.072,21.215-.391.266-5.777,4.556-8.455,7.218.3-2.489.673-5.151,1.159-8.016a78.712,78.712,0,0,1,7.045-10.443c7-8.674,17.645-13.762,25.207-22.045,2.317-2.536,5.37-11.648-1.707-9.394-3.131,1.018-6.858,5.777-9.316,7.969-6.952,6.263-14.091,12.932-18.631,21.168.188-.814.391-1.566.579-2.458a174.728,174.728,0,0,1,16.439-22.185c10.052-11.445,20.354-18.929,20.526-25.176s-12.791,4.227-23.8,18.569a75.027,75.027,0,0,0-11.461,21.778c2.02-8.126,4.165-16.314,6.263-24.174,1.44-3.914,5.715-14.091,13.59-21.152,9.942-8.877,17.989-16.2,19.414-25.051S226.24,305.315,217.409,318.388Zm-55.6,100.7q-2.223-3.037-4.7-6.638a78.282,78.282,0,0,1-1.957-12.447,51.509,51.509,0,0,1,.485-10.756,123.111,123.111,0,0,0,8.5,9.488A47.316,47.316,0,0,1,163,408.053c-.047.454-1.049,7.265-1.19,11.038Zm8.517,10.3a99.62,99.62,0,0,1-6.623-7.828,32.878,32.878,0,0,1,1.018-7.359,53,53,0,0,1,4.1-10.96c3.711,3.523,6.435,5.871,6.435,5.871l6.263,5.48c-.485,5.48-.767,10.6-.939,14.764ZM181.6,413.643l-2.8-2.458c-1.566-1.409-4.384-6.858-7.453-13.12a74.773,74.773,0,0,0,3.476-8.141c3.319,6.153,6.263,10.96,8,13.512C182.4,406.848,181.931,410.292,181.6,413.643Z",
    transform: "translate(-53.971 -227.692)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-229",
    transform: "translate(160.497 142.627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 65.727,
    cy: 14.232,
    rx: 65.727,
    ry: 14.232,
    transform: "translate(0 427.936)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 65.727,
    cy: 14.232,
    rx: 65.727,
    ry: 14.232,
    transform: "translate(0 427.936)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 65.727,
    cy: 14.232,
    rx: 65.727,
    ry: 14.232,
    transform: "translate(238.482 427.936)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 65.727,
    cy: 14.232,
    rx: 65.727,
    ry: 14.232,
    transform: "translate(238.482 427.936)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M248.22,238.63a21.92,21.92,0,0,1,6.638,6.466c1.973,3.585,10.239,5.918,10.239,5.918h3.053l1.253,14.357a74.021,74.021,0,0,0-9.394.908,30.748,30.748,0,0,1-5.574.7s-9.691-12.2-11.3-14.529-1.785-7.171-1.065-8.079S248.22,238.63,248.22,238.63Z",
    transform: "translate(-54.328 -56.3)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M238.915,254.3s-5.386,1.8-3.053,3.241a6.341,6.341,0,0,0,7.186-1.44C243.941,254.663,241.107,253.583,238.915,254.3Z",
    transform: "translate(-57.94 -47.564)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M234.29,245.576s15.97-5.746,16.69-5.214,1.973,5.386,1.973,5.386,11.116,6.638,12.024,9.159a32.706,32.706,0,0,1,0,11.836c-.548.908-3.585,1.973-4.7,2.333a7.093,7.093,0,0,1-3.413,0c-.532-.172-9.159-6.263-9.159-6.263s-8.783.892-10.756.892-3.961-.172-3.961-.172Z",
    transform: "translate(-59.233 -55.339)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M246.54,248s5.918,3.241,7.186,5.026,2.505,9.519,2.505,9.519",
    transform: "translate(-51.568 -50.999)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M244.94,250.1s7,3.758,7.7,5.558a56.358,56.358,0,0,1,1.566,7",
    transform: "translate(-52.473 -49.812)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M251.836,242.085s-7.719,8.611-9.519,9.519-2.145-.188-3.131-.908,5.746-10.4,5.574-11.116a5.245,5.245,0,0,1,6.451.172",
    transform: "translate(-55.784 -56.342)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M240.458,253.825l-.282.971a19.994,19.994,0,0,0-.986,5.308c.36.72,2.521,1.44,3.241.36s2.145-6.451,1.785-7.171S242.447,249.456,240.458,253.825Z",
    transform: "translate(-55.726 -48.996)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M245.3,253.116c-.564.7-3.131,8.439-2.505,9.394s3.225,1.268,3.945.188,3.225-7.828,2.505-9.394S247.868,250.063,245.3,253.116Z",
    transform: "translate(-53.741 -49.07)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M248.239,254.187l-.266.626c-.783,1.863-3.022,7.484-2.427,8.533s4.118,1.566,4.838-.172,3.241-8.439,1.566-10.052a2.114,2.114,0,0,0-3.711,1.065Z",
    transform: "translate(-52.186 -48.528)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M169.364,159s.939,5.777-.141,8.079-2.693,7.124-2.693,7.124l23.829,21.136s7.265-9.159,8.611-10.96,3.131-4.18,3.131-4.18-11.711-7.406-14.091-12.791-1.206-12.244-6.263-13.324S170.851,155.777,169.364,159Z",
    transform: "translate(-96.827 -104.258)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M216.629,141.253s9.958-.141,7.938-9.691-25.3-11.586-29.607-7.139-3.632,6.263-3.632,6.263-20.056-.532-25.176,10.365-2.818,25.051.548,32.441,9.018,8.2,11.977,7.265,5.1-2.693,5.1-5.386,1.894-9.143,4.18-7.531,4.7,2.145,8.752-1.754,9.817-8.752,7.672-12.651-5.793-4.039-3.773-5.793,13.465-3.131,14.529-4.306a8.954,8.954,0,0,0,1.487-2.082Z",
    transform: "translate(-98.734 -122.174)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M214.586,130.7s1.409,2.834-11.993,6.357-36.01,4.227-36.684,12.7",
    transform: "translate(-97.177 -117.352)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M187.948,141.07S171.728,146,168.19,151.654s1.425,10.568,1.425,10.568",
    transform: "translate(-96.608 -111.486)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M212.055,134.36s3.773,12.776,3.773,15.344-2.693,5.1-1.487,7.938,5.245,8.345,5.245,10.1-5.918,3.491-5.918,3.491-4.979,18.788-6.059,21.136-4.7,2.693-9.018,1.566S182.855,186.794,179.8,182.1s-.814-12.666-.814-12.666-6.263-2.818-7.531-8.736,3.366-9.832,7.406-8.486a8.517,8.517,0,0,1,5.245,4.446s.407,1.472,1.566,1.08,2.286-2.834,3.366-2.975,8.752-2.818,7.828-5.777-10.506-3.131-9.832-6.466S212.055,134.36,212.055,134.36Z",
    transform: "translate(-94.16 -115.282)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 3.899,
    y2: 2.693,
    transform: "translate(102.019 53.257)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M188.71,157.31s1.221,3.225,6.263,4.306",
    transform: "translate(-84.28 -102.3)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M189.116,157.91s-2.286,6.263.532,7.672,4.039-4.431,4.039-4.431Z",
    transform: "translate(-84.545 -101.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M199.636,152.047c-.157,3.272-.986,5.887-1.847,5.84s-1.409-2.724-1.237-6,.986-5.871,1.847-5.84S199.808,148.774,199.636,152.047Z",
    transform: "translate(-79.863 -108.669)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 27.462,
    transform: "translate(89.227 40.074)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M195.33,146.694a4.869,4.869,0,0,1,2.959-3.241c2.3-.673,2.693.548,2.693.548",
    transform: "translate(-80.536 -110.252)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M137.15,292.035l83.45-2.505s5.2,57.773,3.945,59.041-83.982,4.7-83.982,4.7-6.4.454-7.312-2.411S137.15,292.035,137.15,292.035Z",
    transform: "translate(-115.716 -27.507)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M138.094,291.13s-7.828,57.241-6.466,58.869,7.828,2.8,9.879,2.333C143.386,351.987,138.094,291.13,138.094,291.13Z",
    transform: "translate(-116.66 -26.602)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M153.568,392.674c-4.587,2.8-6.811,7.531-5.73,11.3s1.425,4.133,4.306,4.7,15.782-1.44,29.748-3.773,15.985-2.865,17.222-4.838,3.413-3.945-10.412-6.263-15.077-4.854-15.077-4.854S160.926,388.181,153.568,392.674Z",
    transform: "translate(-107.553 28.702)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M198.306,393.69c-.939,1.926-3.883,5.386-13.136,6.5-9.785,1.174-27.493,2.943-36.84,3.742.642,1.331,1.425,1.566,3.382,2,2.865.532,15.782-1.44,29.748-3.773s15.985-2.865,17.222-4.838C199.48,396.132,200.561,394.943,198.306,393.69Z",
    transform: "translate(-107.122 31.412)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M176.134,394.4s14.357,6.826,22.264,8.439,9.864,1.8,8.971,4.306-1.08,3.241-13.1,6.106-25.129-.36-30.875-1.44-7.531.548-10.036-.532-1.8-6.466-1.8-6.466Z",
    transform: "translate(-105.35 31.814)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M194.227,408.425c10.1-2.411,11.836-3.3,12.666-5.026-10.96,4.7-25.489,2.756-36.574,1.487-7.139-.83-13.95-1.566-18.788-1.957a4.024,4.024,0,0,0,1.832,3.523c2.505,1.08,4.306-.532,10.036.532S182.2,411.291,194.227,408.425Z",
    transform: "translate(-105.313 36.639)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M164.376,310.409s-2.521,20.448-7.547,29.247-11.836,14.89-12.917,27.634,2.505,64.787,2.865,69.281-1.566,5.918.36,8.783a49.934,49.934,0,0,0,3.945,5.026l5.934-5.2s4.306-13.825,3.225-40.206-.892-44.136,3.773-61.734,5.558-22.248,3.4-29.074S164.376,310.409,164.376,310.409Z",
    transform: "translate(-109.735 -16.086)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M150.315,284.166s5.918,11.163,7.265,14.091,4.431,36.887,2.02,48.191-11.805,30.515-10.96,47.377,1.566,61.562,1.566,62.094a20.353,20.353,0,0,0,0,8.079c.892,4.838,3.585,6.263,3.585,6.263a89.876,89.876,0,0,1,14.169-5.2c8.8-2.521,11.3-6.106,11.3-6.106a64.73,64.73,0,0,0-2.693-6.826c-1.253-2.505-3.4-6.451-3.037-7.719s2.693-42.523,7.359-56.16,7.343-27.994,11.3-40.566,13.4-46.25,13.4-54.861V282.24l-55.988-1.08Z",
    transform: "translate(-106.977 -32.242)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M154.812,334.44c-1.566,4.807-3.3,10.192-4.619,14.467-3.131,10.177,0,67.324,0,67.324a107.567,107.567,0,0,1,.3,12.525c-.3,5.182,0,7.233,1.284,8.627",
    transform: "translate(-106.855 -2.103)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M156.169,326.68s-1.159,3.46-2.709,8.2",
    transform: "translate(-104.22 -6.493)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M167.355,163.76s6.263,2.145,15.657,10.365,18.976,16.017,16.956,18.788-5.793,12.525-5.793,12.525-3.491-5.793-13.856-14.091S162,175.6,162,175.6,166.274,165.514,167.355,163.76Z",
    transform: "translate(-99.389 -98.651)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M171.454,172.18s-20.056,14.263-23.485,27.994-4.854,20.463-4.572,46.7,1.879,42.805,1.879,44.011S140,340.833,140,341.366s9.394,9.159,35.666,9.691a316.466,316.466,0,0,0,53.233-4.165L217.453,252.4s-4.447-40.253-9.018-47.784S171.454,172.18,171.454,172.18Z",
    transform: "translate(-111.834 -93.888)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M167.48,256.124s16.69,3.366,28.182-.814",
    transform: "translate(-96.289 -46.864)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M167.48,259.289s16.69,3.366,28.182-.8",
    transform: "translate(-96.289 -45.066)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M232.885,241.96l4.133,1.973L234.5,262.6l-4.118-.72Z",
    transform: "translate(-60.709 -54.416)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M179.518,187.86a13.652,13.652,0,0,0-6.09,3.945c-2.693,3.131-17.222,21.168-16.158,29.074s19.962,36.777,26.225,45.764a65.383,65.383,0,0,0,31.736,24.769c15.8,5.746,56.9,2.881,56.9,2.881l2.176-22.279s-22.42-7.171-37.858-11.836a191.2,191.2,0,0,1-25.129-9.394s-3.585-8.8-6.106-10.224-2.865-2.333-2.865-2.333-4.838-26.381-7.359-35.008-5.918-10.756-5.918-10.756",
    transform: "translate(-102.096 -85.018)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M316.3,388.65a156.705,156.705,0,0,1-19.915,9.691c-9.159,3.413-11.32,4.7-9.519,6.638s17.41,3.413,26.194,1.566,12.212-3.037,16.158-2.865,9.394,1.253,11.3-1.44,2.693-3.225,1.253-7.719S316.3,388.65,316.3,388.65Z",
    transform: "translate(-29.084 28.561)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M313.052,403.393c8.8-1.785,12.212-3.037,16.158-2.865s9.394,1.253,11.3-1.44c1.409-1.926,2.176-2.756,1.973-4.7-6.388-.532-18.71,1.487-33.4,4.7a60.889,60.889,0,0,1-22.718,1.159,1.456,1.456,0,0,0,.485,1.566C288.659,403.753,304.269,405.194,313.052,403.393Z",
    transform: "translate(-29.072 31.76)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M336.742,396.22a127.605,127.605,0,0,1-11.476,10.96c-5.934,4.838-16.158,11.492-15.077,14.357s8.423,5.558,23.861,1.566a89.932,89.932,0,0,0,27.634-12.917,6.92,6.92,0,0,0,4.306-2.693c1.268-2.161-.172-5.558-.172-5.558Z",
    transform: "translate(-15.609 32.843)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M333.466,420.916A89.93,89.93,0,0,0,361.1,408a6.92,6.92,0,0,0,4.306-2.693,6.763,6.763,0,0,0,0-5.167c-22.326,16.893-43.212,20.354-54.266,20.855C314.052,423,321.223,424.048,333.466,420.916Z",
    transform: "translate(-15.026 35.061)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M321.266,264.75s-9.5,1.268-16.33-1.253-13.277-4.478-13.277-4.478-3.773,48.99.36,68.733,15.077,43.839,15.25,49.35A117.43,117.43,0,0,0,309.6,396.83c1.253,5.026,7.359,43.839,7.719,48.1a29.163,29.163,0,0,1,0,6.466s-4.306,1.44-4.306,2.693v9.143a59.872,59.872,0,0,0,11.132,4.493c6.638,1.973,15.97,3.585,15.97,3.585a98.247,98.247,0,0,0,1.785-10.96c0-2.505-1.566-9.143-1.566-12.745s.908-46.657.908-46.657,8.783,36.793,8.783,48.99-.172,16.158-.172,16.158-3.945-1.253-3.945,1.44-.188,9.143-.188,9.143,14,3.585,20.635,5.558a26.366,26.366,0,0,0,12.212.72s3.585-13.637,3.225-18.115-4.838-8.267-4.838-10.772,2.333-27.274-1.08-48.817-12.384-31.407-12.745-41.991,1.566-48.63,1.8-54.8,6.451-19.023,7.359-24.769.172-22.78.172-22.78S332.225,266.723,321.266,264.75Z",
    transform: "translate(-26.937 -44.766)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 9.691,
    y2: 6.278,
    transform: "translate(277.169 244.581)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M321.38,346.16c1.346,3.491,2.176,5.511,2.176,5.511",
    transform: "translate(-9.234 4.526)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M303.17,281.37s6.451,37.858,14.169,61.546c3.961,12.15,8.2,23.8,11.4,32.237",
    transform: "translate(-19.534 -32.123)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M256.63,248.515c.172.532,1.065,20.1,1.065,20.1l51.51-4.7-1.065-25.3Z",
    transform: "translate(-45.86 -56.305)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M335.833,183.043s-11.664,4.118-14,7-16.158,51.495-20.7,65.852-5.918,57.789-5.918,57.789a49.281,49.281,0,0,0,7.719,2.161,39.568,39.568,0,0,0,7.828.532s15.077-50.79,22.436-68.185,19.727-42.351,24.409-52.043,8.783-11.492,8.251-16.158-2.693-6.466-5.386-6.826S335.833,183.043,335.833,183.043Z",
    transform: "translate(-24.031 -93.337)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M336.741,182.133s-11.664,4.118-14,7-16.142,51.495-20.588,65.852-5.965,57.789-5.965,57.789a49.27,49.27,0,0,0,7.719,2.161,40.97,40.97,0,0,0,7.828.532s15.077-50.79,22.436-68.2,19.743-42.273,24.409-52.043,8.783-11.476,8.251-16.142-2.693-6.466-5.386-6.826S336.741,182.133,336.741,182.133Z",
    transform: "translate(-23.483 -93.852)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M348.454,186.929a305.3,305.3,0,0,0-19.2,38.954c-7.359,19.023-13.277,36.01-20.823,61.374a128.746,128.746,0,0,0-4.478,48.269s3.585,6.106,24.769,6.826,47.737-6.106,47.737-6.106-3.6-21.544-3.961-34.272,9.879-57.429,14.185-69.093,13.637-23.328,4.7-34.632S361.058,174.2,361.058,174.2,350.787,182.983,348.454,186.929Z",
    transform: "translate(-19.43 -92.745)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M335.493,182.494s-5.558,7-10.584,21.919-14.357,54.563-18.663,71.426-6.466,54.376-6.466,54.376-2.333-.172-7.171-.172a21.684,21.684,0,0,1-9.159-2.333s3.413-36.793,6.466-54.015,12.024-47.925,13.637-59.949,2.145-15.062,4.306-16.69,19.023-11.836,22.436-14.169S335.493,182.494,335.493,182.494Z",
    transform: "translate(-30.689 -88.483)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M363.47,176.72S353.247,197,350.554,200.769a48.792,48.792,0,0,0-4.133,6.811l-8.971,3.413,3.585,5.746s-18.115,32.441-22.78,43.244-9.394,22.436-9.394,22.436",
    transform: "translate(-16.316 -91.32)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M296.791,235.07c-.329,3.585-.391,5.01-.391,5.01",
    transform: "translate(-23.364 -58.313)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M318.656,186.23,308.6,201.667l2.333,3.585-5.574,6.826s-5.918,24.581-7.531,37.858c-.313,2.583-.579,4.838-.783,6.795",
    transform: "translate(-22.996 -85.941)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M312.823,181.99l-1.973,9.5,10.224-6.811Z",
    transform: "translate(-15.19 -88.339)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M320.721,177.18c-.188.532-8.611,7.531-8.611,7.531l9.5,3.945,1.973-7.719Z",
    transform: "translate(-14.477 -91.06)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M322.955,132.746A23.657,23.657,0,0,0,313.8,143.33c-3.225,7.359-5.73,10.412-5.01,12.745a24.783,24.783,0,0,1,1.065,4.854c0,.532-7.531,7.719-7.719,9.864s4.854,6.106,4.854,6.106.532,12.384.532,13.465.36,6.638,5.574,8.063a22.389,22.389,0,0,0,10.756-.172l3.413,17.582s23.876-14.717,26.381-15.97,5.558-2.865,5.746-4.838-1.44-12.932-1.44-12.932,12.745-11.664,12.525-25.3-7.484-22.248-20.776-26.3S322.955,132.746,322.955,132.746Z",
    transform: "translate(-20.124 -118.239)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M364.043,156.83c-.172-13.637-7.531-22.248-20.808-26.381s-26.742,2.333-26.742,2.333a18.945,18.945,0,0,0-2.943,2.176c4.384-.783,11.6-1.331,16.768,1.957,7.828,5.026,2.865,10.052.172,12.745s-3.225,3.758-1.253,6.263,5.746,2.505,4.838,4.838-3.585,5.574-1.425,6.466,4.118-1.08,5.026-3.773,5.37-2.693,7.171,2.881A10.631,10.631,0,0,1,341.074,178a7.39,7.39,0,0,1-5.026,1.425,45.406,45.406,0,0,0,9.691,3.6,18.13,18.13,0,0,0,5.809-.454v-.454S364.231,170.467,364.043,156.83Z",
    transform: "translate(-13.663 -118.275)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M313.163,152.175c0,1.393-.438,2.521-.986,2.521s-.986-1.127-.986-2.521.438-2.505.986-2.505S313.163,150.8,313.163,152.175Z",
    transform: "translate(-14.998 -106.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M309.47,147.306s.72-2.521,4.7-2.333,4.133,3.053,4.133,3.053",
    transform: "translate(-15.971 -109.283)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M305.23,161.524a7.249,7.249,0,0,0,6.638-.892c2.865-2.333.532-4.321.532-4.321",
    transform: "translate(-18.369 -102.865)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M306.446,163.219s9.5-4.7,13.809-4.838,8.8,7.233,7.03,13.5-3.758,9.394-9.864,11.852-11.852,1.973-12.917-2.161,3.758-10.036,6.09-11.116,4.133-1.253,3.773.72-1.44,3.4,3.053,2.505,7-2.145,7.171-7-1.566-6.638-6.263-5.918-11.664,4.478-11.664,4.478Z",
    transform: "translate(-18.865 -101.695)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M308.09,165.113s7.547-.36,10.239-3.413",
    transform: "translate(-16.751 -99.816)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M328.771,161.13a9.911,9.911,0,0,1-3.6,7.719",
    transform: "translate(-7.09 -100.139)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M318.18,192.781l5.214,12.024s19.727-14.717,24.581-20.463,8.611-8.611,5.918-12.525-6.638-.72-7.359-.36S318.18,192.781,318.18,192.781Z",
    transform: "translate(-11.044 -95.185)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M309.749,270.493a188.859,188.859,0,0,1-5.37-22.154c-1.08-6.873-1.566-13.872-1.566-13.872a77.533,77.533,0,0,1-25.066-6.638C265.911,222.1,263.39,220,263.39,220s15.97,52.043,19.211,62.987,3.945,13.277,3.945,13.277a67.169,67.169,0,0,0,16.142,5.574,85.828,85.828,0,0,0,13.465,1.425Z",
    transform: "translate(-42.036 -66.838)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M318.9,254.677a43.684,43.684,0,0,1-10.96-3.585,26.617,26.617,0,0,0-8.423-3.131h-.72l2.145,6.638a38.548,38.548,0,0,1-8.063.908c-4.306,0-13.292-1.44-13.637-.908a12.259,12.259,0,0,0-.36,3.945c0,1.268,6.451,8.987,10.224,11.68s7.171,4.478,10.584,4.478S321.4,272.2,321.4,272.2Z",
    transform: "translate(-33.291 -51.022)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M357.358,217.447s.892,20.1,1.44,34.632,1.44,15.8,1.44,15.8-40.206,15.077-46.312,16.33S303.17,286.9,303.17,286.9l2.693,19.555A112.54,112.54,0,0,0,345,302.87c19.571-5.746,49.71-11.492,50.258-14.169s0-10.772,0-12.525-.548-40.378-.548-57.6,1.253-21.183-.892-24.769-13.1-5.386-19.383-1.8",
    transform: "translate(-19.534 -83.778)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M318.39,267.3l33.239-11.539-2.943-44.293",
    transform: "translate(-10.925 -71.663)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    y1: 1.66,
    x2: 4.807,
    transform: "translate(298.134 197.22)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M345.1,200.77s12.525-15.657,24.972-7.5",
    transform: "translate(4.184 -83.29)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M279.32,253.4s8.267,5.558,13.825,6.466",
    transform: "translate(-33.025 -47.945)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M280.24,256.84a27.791,27.791,0,0,0,8.251,5.026l3.773,1.065",
    transform: "translate(-32.505 -45.999)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M286,262.57a24.783,24.783,0,0,0,6.638,1.44",
    transform: "translate(-29.247 -42.758)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M205.194,251.343s-2.474-25.285-5.386-43.1c-1.566-9.848-7.531-18.24-13.762-25.755-5.151-6.263-12.932-11.993-17.222-18.647-1.487-2.286-9.284,14.248-9.3,14.263-1.566,3.523,16.987,14.686,19.493,17.222,3.288,3.288,6.263,7.171,9.253,10.709,1.362,1.566,4.948,7.531,7,8.032l3.319.83-2.489,7.468Z",
    transform: "translate(-100.843 -98.729)",
    fill: "#0074d7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 610,
    height: 610,
    transform: "translate(218 297)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailValidArt);
export default __webpack_public_path__ + "static/media/email_valid_art.ed6ef28f53305056efe5cb87a2b34e0b.svg";
export { ForwardRef as ReactComponent };